<template lang="pug">
  div
    v-data-table(
      class="pt-4",
      :headers="headers",
      :items="list",
      :loading="loading",
      no-data-text="Нет подразделений для указаной организации",
      hide-actions)
      template(slot="items" slot-scope="props")
        td {{ props.index + 1 }}
        td {{ props.item.name }}
        td
          a(@click="goToDivisionsList(props.item.id, props.item)") Просмотреть
        td
          a(@click="editDivision(props.item.id, props.item)") Редактировать
        td
          a(@click="deleteDivision(props.item.id, props.item.name)", class="red--text") Удалить
</template>

<script>
import EditDivision from '../../EditDivision/EditDivision'
export default {
  name: 'Table',
  components: { EditDivision },
  props: {
    organisationId: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    headers: [
      { text: '№', value: 'id', sortable: false },
      { text: 'Название', value: 'name' },
      { text: 'Действие', value: 'action1', sortable: false, align: 'left' },
      { text: 'Действие', value: 'action2', sortable: false, align: 'left' },
      { text: 'Действие', value: 'action3', sortable: false, align: 'left' }
    ],
    loading: false
  }),
  methods: {
    goToDivisionsList(id, data) {
      this.$router.push({ path: `/main/organisation/division/${id}` })
      this.$store.commit('SAVE_DIVISION_ITEM', data)
    },
    deleteDivision(id, name) {
      this.$emit('delete-division', id, name)
    },
    editDivision(id, data) {
      this.$router.push({ path: `/main/organisation/division/edit/${id}` })
      this.$store.commit('SAVE_DIVISION_ITEM', data)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/OrganisationStructure/Division/DivisionList/common/Table.vue